"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
//  group by key then return array of object with key and values
var groupBy = function (arr, k) {
    if (Array.isArray(arr) === false) {
        return null;
    }
    var grouped = arr.reduce(function (prev, curr) {
        var _a;
        var val = curr[k];
        var group = prev[String(val)] || [];
        group.push(curr);
        return __assign(__assign({}, prev), (_a = {}, _a[String(val)] = group, _a));
    }, {});
    return Object.keys(grouped).map(function (key) {
        return {
            key: key,
            values: grouped[key],
        };
    });
};
exports.default = groupBy;
